<div class="mce-editor-wrapper">

  <!-- Toolbar -->
    <div class="mce-editor-toolbar">

        <!-- Block format dropdown -->
        <select class="mce-format-select" [value]="activeBlockType()" (change)="setBlockType($any($event.target).value)" title="Text format">
            <option value="paragraph">Paragraph</option>
            <option value="h1">Heading 1</option>
            <option value="h2">Heading 2</option>
            <option value="h3">Heading 3</option>
        </select>

        <span class="mce-editor-separator"></span>

        <!-- Text style -->
        <button type="button" (click)="editor.chain().focus().toggleBold().run()" [class.active]="isActive('bold')" title="Bold"><b>B</b></button>
        <button type="button" (click)="editor.chain().focus().toggleItalic().run()" [class.active]="isActive('italic')" title="Italic"><i>I</i></button>
        <button type="button" (click)="editor.chain().focus().toggleUnderline().run()" [class.active]="isActive('underline')" title="Underline"><u>U</u></button>
        <button type="button" (click)="editor.chain().focus().toggleStrike().run()" [class.active]="isActive('strike')" title="Strikethrough"><s>S</s></button>

        <span class="mce-editor-separator"></span>

        <!-- Colour -->
        <mce-color-palette label="Font colour" removeLabel="Remove colour" [currentColor]="currentColor()" (colorSelected)="setColor($event)">
            <mat-icon>format_color_text</mat-icon>
        </mce-color-palette>
        <mce-color-palette label="Background colour" removeLabel="Remove background" [currentColor]="currentHighlight()" (colorSelected)="setHighlight($event)">
            <mat-icon>format_color_fill</mat-icon>
        </mce-color-palette>

        <span class="mce-editor-separator"></span>

        <!-- Lists -->
        <button type="button" (click)="editor.chain().focus().toggleBulletList().run()" [class.active]="isActive('bulletList')" title="Bullet list">
            <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()" [class.active]="isActive('orderedList')" title="Ordered list">
            <mat-icon>format_list_numbered</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().sinkListItem('listItem').run()" title="Increase indent">
            <mat-icon>format_indent_increase</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().liftListItem('listItem').run()" title="Decrease indent">
            <mat-icon>format_indent_decrease</mat-icon>
        </button>

        <span class="mce-editor-separator"></span>

        <!-- Alignment -->
        <button type="button" (click)="setAlign('left')" [class.active]="isActive({ textAlign: 'left' })" title="Align left">
            <mat-icon>format_align_left</mat-icon>
        </button>
        <button type="button" (click)="setAlign('center')" [class.active]="isActive({ textAlign: 'center' })" title="Align centre">
            <mat-icon>format_align_center</mat-icon>
        </button>
        <button type="button" (click)="setAlign('right')" [class.active]="isActive({ textAlign: 'right' })" title="Align right">
            <mat-icon>format_align_right</mat-icon>
        </button>

        <span class="mce-editor-separator"></span>

        <!-- Blocks -->
        <button type="button" (click)="editor.chain().focus().toggleBlockquote().run()" [class.active]="isActive('blockquote')" title="Blockquote">
            <mat-icon>format_quote</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().toggleCodeBlock().run()" [class.active]="isActive('codeBlock')" title="Code block">
            <mat-icon>code</mat-icon>
        </button>

        <span class="mce-editor-separator"></span>



        <!-- Link -->
        <button type="button" (click)="insertLink()" [class.active]="isActive('link')" title="Insert link">
            <mat-icon>link</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().unsetLink().run()" [disabled]="!isActive('link')" title="Remove link">
            <mat-icon>link_off</mat-icon>
        </button>

        <span class="mce-editor-separator"></span>
        <button type="button" (click)="editor.chain().focus().undo().run()" title="Undo">
            <mat-icon>undo</mat-icon>
        </button>
        <button type="button" (click)="editor.chain().focus().redo().run()" title="Redo">
            <mat-icon>redo</mat-icon>
        </button>

        <span class="mce-editor-separator"></span>

        <!-- More menu -->
        <div class="mce-more-wrap">
            <button type="button" (click)="toggleMoreMenu($event)" [class.active]="showMoreMenu()" title="More options">
                <mat-icon>more_vert</mat-icon>
            </button>
            <div *ngIf="showMoreMenu()" class="mce-more-dropdown" (click)="$event.stopPropagation()">

                <div class="mce-more-section-label">Insert</div>

                <button type="button" class="mce-more-item" (click)="insertImage(); showMoreMenu.set(false)" title="Insert image from URL">
                    <mat-icon>image_search</mat-icon>
                    <span class="mce-more-item-label">Image from URL</span>
                </button>
                <button type="button" class="mce-more-item" (click)="openImageUpload()" title="Upload image">
                    <mat-icon>image</mat-icon>
                    <span class="mce-more-item-label">Upload image</span>
                </button>

                <div class="mce-more-item-wrap">
                    <button type="button" class="mce-more-item" (click)="toggleTablePicker($event)" title="Insert table">
                        <mat-icon>table_chart</mat-icon>
                        <span class="mce-more-item-label">Insert table</span>
                        <mat-icon class="mce-more-chevron">{{ showTablePicker() ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                    <div *ngIf="showTablePicker()" class="mce-more-table-picker" (click)="$event.stopPropagation()">
                        <mce-table-grid-picker (tableSelected)="insertTable($event.rows, $event.cols); showMoreMenu.set(false)" />
                    </div>
                </div>

                <button type="button" class="mce-more-item" (click)="insertEquation(); showMoreMenu.set(false)" title="Insert equation">
                    <mat-icon>functions</mat-icon>
                    <span class="mce-more-item-label">Insert equation</span>
                </button>
                <button type="button" class="mce-more-item" [disabled]="!isEquationSelected()" (click)="editEquation(); showMoreMenu.set(false)" title="Edit equation">
                    <mat-icon>edit</mat-icon>
                    <span class="mce-more-item-label">Edit equation</span>
                </button>

                <div class="mce-more-divider"></div>
                <div class="mce-more-section-label">Edit</div>

                <button type="button" class="mce-more-item" (click)="editor.chain().focus().toggleSuperscript().run(); showMoreMenu.set(false)" [class.active]="isActive('superscript')" title="Superscript">
                    <span class="mce-more-item-glyph">X<sup>2</sup></span>
                    <span class="mce-more-item-label">Superscript</span>
                </button>
                <button type="button" class="mce-more-item" (click)="editor.chain().focus().toggleSubscript().run(); showMoreMenu.set(false)" [class.active]="isActive('subscript')" title="Subscript">
                    <span class="mce-more-item-glyph">X<sub>2</sub></span>
                    <span class="mce-more-item-label">Subscript</span>
                </button>
                <button type="button" class="mce-more-item" (click)="clearFormatting(); showMoreMenu.set(false)" title="Clear formatting">
                    <mat-icon>format_clear</mat-icon>
                    <span class="mce-more-item-label">Clear formatting</span>
                </button>

            </div>
        </div>
        <input #fileInput type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="insertImageFromFile($event)" />

    </div>

  <div *ngIf="imageUploadError()" class="mce-editor-error">
    {{ imageUploadError() }}
  </div>

  <!-- Contextual table toolbar -->
  <div *ngIf="isInTable()" class="mce-table-toolbar">
    <mat-icon class="mce-table-toolbar-label" title="Table options">table_chart</mat-icon>
    <span class="mce-editor-separator"></span>
    <button type="button" (click)="addRowBefore()" title="Add row before">
      <mat-icon>vertical_align_top</mat-icon>
    </button>
    <button type="button" (click)="addRowAfter()" title="Add row after">
      <mat-icon>vertical_align_bottom</mat-icon>
    </button>
    <button type="button" (click)="deleteRow()" title="Delete row">
      <mat-icon>remove</mat-icon>
    </button>
    <span class="mce-editor-separator"></span>
    <button type="button" (click)="addColumnBefore()" title="Add column before">
      <mat-icon>keyboard_tab</mat-icon>
    </button>
    <button type="button" (click)="addColumnAfter()" title="Add column after">
      <mat-icon>keyboard_tab</mat-icon>
    </button>
    <button type="button" (click)="deleteColumn()" title="Delete column">
      <mat-icon>remove</mat-icon>
    </button>
    <span class="mce-editor-separator"></span>
    <button type="button" (click)="mergeCells()" title="Merge cells">
      <mat-icon>merge</mat-icon>
    </button>
    <button type="button" (click)="splitCell()" title="Split cell">
      <mat-icon>call_split</mat-icon>
    </button>
    <span class="mce-editor-separator"></span>
    <button type="button" (click)="toggleHeaderRow()" title="Toggle header row">
      <mat-icon>table_rows</mat-icon>
    </button>
    <button type="button" (click)="toggleHeaderColumn()" title="Toggle header column">
      <mat-icon>view_column</mat-icon>
    </button>
    <span class="mce-editor-separator"></span>
    <button type="button" (click)="deleteTable()" title="Delete table" class="mce-btn-danger">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <!-- Editor content area -->
  <div class="mce-editor-content" [editor]="editor" tiptap></div>

</div>
